module.exports = __webpack_public_path__ + "assets/feelgood_plus.zip?3f579140de713f671b6b7bbd5c066595";